import { Component, OnInit } from '@angular/core';
import { DataModelService } from '@services/data-model.service';
import { PageTitleService } from '@services/page-title.service';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'app-type-list',
    templateUrl: './type-list.component.html',
    styleUrls: ['./type-list.component.scss'],
    standalone: false
})
export class ModelTypeListComponent implements OnInit {
  /**Menu items for Data Model Categories*/
  catList: MenuItem[] = [];

  constructor(
    private dataModelService: DataModelService,
    private pageTitleService: PageTitleService
  ) {}

  ngOnInit() {
    this.getCategories();

    this.dataModelService.updateTypeListTrigger().subscribe(() => {
      this.getCategories();
    });
    this.pageTitleService.section = 'Model Keys';
  }
  /**
   *Get the category list form the API
   * */
  private getCategories() {
    this.dataModelService.getCategories(true).subscribe(list => {
      if (!list.errorMessage) {
        this.catList = this.processMenu(list);
      }
    });
  }

  /**
   *Convert the data returned from the Categories/Data types api call to a MenuItem[]
   *
   * @returns MenuItem[]
   * */
  processMenu(list: any[]): MenuItem[] {
    let menu: MenuItem[] = [];
    list.forEach(item => {
      menu.push({
        label: item.title,
        icon: item.json_data.iconClass,
        items: this.processMenuChildData(item.types),
      });
    });
    menu.push({
      label: 'Preferences',
      icon: 'fas fa-cogs',
      routerLink: '/data-models/preferences',
    });
    return menu;
  }
  /**
   * Convert the child types for each category to a MenuItem[]
   * @param menu_children Child types to be added to menu
   */
  processMenuChildData(menu_children: any[]): MenuItem[] {
    let children: MenuItem[] = [];
    menu_children.forEach(item => {
      children.push({
        label: item.name,
        routerLink: '/data-models/' + item.name,
      });
    });
    return children;
  }
}
